'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _func_1 = require("./_func");
var OrderItem;
(function (OrderItem) {
    var MyOrderItem = /** @class */ (function () {
        function MyOrderItem() {
            var self = this;
            // 数量変更
            $(document).on('click', '.trigCount', function () {
                var itemId = $(this).attr('data-id');
                var vector = $(this).attr('data-vector');
                var val = MyOrderItem.getNewQuantity(itemId, vector);
                var page = $(this).attr('data-page');
                if (page == 'detail') {
                    MyOrderItem.setSubtotal(val);
                }
            });
            $(document).on('click', '#trigQuantity', function () {
                var elm = document.getElementById('trigQuantity');
                elm.setSelectionRange(100, 100);
            });
            $(document).on('keyup', '#trigQuantity', function () {
                var val = Number($(this).val());
                if (!val) {
                    val = 1;
                }
                MyOrderItem.setSubtotal(val);
            });
        }
        MyOrderItem.getNewQuantity = function (itemId, vector) {
            var input = $('.bulletQuantity[data-id="' + itemId + '"]');
            var val = Number(input.val());
            if (vector == "-1") {
                val--;
                if (val < 1) {
                    val = 1;
                }
            }
            else {
                val++;
            }
            input.val(val);
            return val;
        };
        MyOrderItem.setSubtotal = function (val) {
            var unitPrice = Number($('#paramUnitPrice').val());
            var subtotal = unitPrice * val;
            if (val >= 0) {
                $('.bulletSubtotal').html(_func_1.default.numberFormat(_func_1.default.getTaxIn(subtotal, 10)));
            }
            else {
                $('.bulletSubtotal').html('0');
            }
        };
        return MyOrderItem;
    }());
    OrderItem.MyOrderItem = MyOrderItem;
})(OrderItem || (OrderItem = {}));
exports.default = OrderItem;
